import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'submitPaymentProgram');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'paya',
  slug: ['transactions'],
  type: 'post',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/submitPaymentProgram.js